import { cn } from "@/lib/utils";
import { STATUS_LABELS } from "@/lib/format";
import type { ShipmentStatus } from "@/lib/types";

type Tone = "success" | "warning" | "error" | "neutral" | "primary";

const TONE_CLASS: Record<Tone, string> = {
  success: "bg-success/10 text-success",
  warning: "bg-warning/15 text-warning-foreground",
  error: "bg-destructive/10 text-destructive",
  neutral: "bg-muted text-muted-foreground",
  primary: "bg-primary/10 text-primary",
};

export function Pill({
  children,
  tone = "neutral",
  className,
}: {
  children: React.ReactNode;
  tone?: Tone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium",
        TONE_CLASS[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}

const STATUS_TONE: Record<ShipmentStatus, Tone> = {
  searching: "warning",
  offered: "warning",
  accepted: "primary",
  en_route_pickup: "primary",
  arrived_pickup: "primary",
  picked_up: "primary",
  in_transit: "primary",
  arrived_dropoff: "primary",
  delivered: "success",
  cancelled: "error",
  expired: "neutral",
  failed: "error",
};

export function ShipmentStatusPill({ status }: { status: ShipmentStatus }) {
  return <Pill tone={STATUS_TONE[status] ?? "neutral"}>{STATUS_LABELS[status] ?? status}</Pill>;
}
